module.exports = __webpack_public_path__ + "static/copy_button-fff0c13eaa97f0ca289673d65f91e121.png";